
export default function ClientsSection() {
  const clientTypes = [
    {
      icon: 'ri-user-line',
      title: 'Credores Individuais',
      description: 'Pessoas físicas que possuem precatórios e buscam liquidez imediata com segurança jurídica.'
    },
    {
      icon: 'ri-building-line',
      title: 'Investidores Institucionais',
      description: 'Fundos e empresas que buscam oportunidades de investimento no mercado de precatórios.'
    },
    {
      icon: 'ri-scales-3-line',
      title: 'Escritórios de Advocacia',
      description: 'Profissionais do direito que atuam com precatórios e buscam parcerias estratégicas.'
    },
    {
      icon: 'ri-funds-line',
      title: 'Fundos de Investimento',
      description: 'Gestores que desejam diversificar portfólio com ativos judiciais de qualidade.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-blue-900 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Quem atendemos
          </h2>
          <p className="text-xl text-blue-900 max-w-3xl mx-auto" style={{ fontFamily: 'Open Sans, sans-serif' }}>
            Atendemos diversos perfis de clientes que buscam segurança, liquidez e oportunidades 
            reais no mercado de precatórios
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {clientTypes.map((client, index) => (
            <div key={index} className="text-center p-6 rounded-xl border border-gray-200 hover:border-blue-300 hover:shadow-lg transition-all duration-300">
              <div className="w-16 h-16 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className={`${client.icon} text-2xl`}></i>
              </div>
              <h3 className="text-xl font-semibold text-blue-900 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>{client.title}</h3>
              <p className="text-blue-900 leading-relaxed" style={{ fontFamily: 'Open Sans, sans-serif' }}>{client.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
